module.exports = __webpack_public_path__ + "static/img/成果介绍.efcfa365.svg";